import { ProjectionsList } from "@hokuto/jam-core";
import { useArea } from "./area.js";
import { BACKGROUND_COLOR, SCALE } from "../const.js";

export function useBase(
  args: Parameters<typeof useArea>["0"] & {
    bgColor?: string;
    scale?: number;
    projection?: ProjectionsList;
  }
) {
  const {
    bgColor = BACKGROUND_COLOR,
    scale = SCALE,
    projection = ProjectionsList.Mercator,
  } = args;

  const { margin, area, width, height } = useArea(args);

  return {
    width,
    height,
    margin,
    area,
    scale,
    bgColor,
    projection,
  };
}
